export default () => ({
  orderInfo: {}, // 订单信息
  accountBalance: '', // 钱包余额
  code: '', // CODE码
  orderStatus: null, // 订单状态
  pending: false, // 等待态
  codeLoading: true, // CODE码是否是loading状态
})
